import config from '~/config';

const location = (loc) => `${loc.lat},${loc.lng}`;
const marker = (label, color, loc) => `&markers=label:${label}|color:${color}|${loc}`;
const markers = (from, to) => `${marker('O', 'green', location(from))}${marker('D', 'red', location(to))}`;

const url = (from, to, width, height, polyline) => {
  let imageSrc = 'https://maps.googleapis.com/maps/api/staticmap'
    + `?key=${config.googleMapsApiKey}&size=${width}x${height}&scale=2&path=weight:5|color:blue`;

  if (polyline) {
    imageSrc += polyline.length < (2000 - imageSrc.length - 5) ? `|enc:${polyline}` : '';
  }

  imageSrc += markers(from, to);
  return imageSrc;
};


export {
  url,
};



// WEBPACK FOOTER //
// ./src/misc/staticmaps.js